import { PartnerType } from './partner';

export interface TradingPartner {
  id: string;
  name: string;
  accountId: string;
  type?: PartnerType;
}

export interface MessageType {
  transactionType: string;
}

export interface TradingPartnerUsers {
  id: string;
  name: string;
  email: string;
}

export interface ListMessageTypesPayload {
  excludeNonIntegratedTransactionTypes?: boolean;
}

export interface TradingPartnerSettings {
  id: string;
  partnerId: string;
  enabled: boolean;
  key: string;
  value: { [key: string]: string };
  createdAt: Date;
  updatedAt: Date | null;
  deletedAt: Date | null;
}
